// import { login, list, detail } from '@/api/login'//引入登录 api 接口

const user = {
  state: {
    // 1 企业 2 银行 3 审核 4 监管
    sourceType: '' || sessionStorage.getItem("sourceType"),  // 登录人类型
    name: "",  // 登录人姓名
    avatar: "",  // 登录人头像
    loginTime: "",  // 登录时间
    bankAuth: '' || sessionStorage.getItem("bankAuth"), //登录人权限
    organization: "",    //用户所属银行
  },
  mutations: {
    setSourceType(state, payload) {
      state.sourceType = payload;
      sessionStorage.setItem("sourceType", payload);
    },
    organization(state, payload) {
      state.organization = payload;
      sessionStorage.setItem("organization", payload);
    },
    setBankAuth(state, payload) {
      state.bankAuth = payload;
      sessionStorage.setItem("bankAuth", payload);
    },
    setUserName(state, payload) {
      state.name = payload;
      sessionStorage.setItem("userName", payload);
    }
  },
  actions: {
    // 登录
    // Login ({ commit }, userInfo) { //定义 Login 方法，在组件中使用 this.$store.dispatch("Login") 调用
    //   const username = userInfo.username.trim()
    //   return new Promise((resolve, reject) => { //封装一个 Promise
    //     login(username, userInfo.password).then(response => { //使用 login 接口进行网络请求
    //       // 提交一个 mutation，通知状态改变
    //       resolve(response) //将结果封装进 Promise
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
  }
}
export default user
